import React from "react";
import { motion } from "framer-motion";
import { TOTAL_LEVEL } from "../../constants/GameConstants";
import "./Header.scss";
import { backgroundMusicStart, backgroundMusicStop } from "../../utilities/sounds";

function getFormattedNumber(num) {
  if (num < 10) {
    return `0${num}`;
  } else {
    return num;
  }
}

const getTotalTimeForALevel = (level) => {
  return 300 + 60 * (level - 1);
};

const getRemainingTimePercentage = (timeLeft, level) => {
  let timeLeftInSeconds = timeLeft.minute * 60 + timeLeft.second;
  let totalTimeForLevel = getTotalTimeForALevel(level);
  return (timeLeftInSeconds / totalTimeForLevel) * 100;
};

const variants = {
  initial: {
    scale: 1
  },
  final: {
    scale: [0.5, 1],
    transition: { duration: 0.3 }
  }
}

const Header = (props) => {
  const { } = props
  const isBgAudioPlaying = JSON.parse(localStorage.getItem("playMusic"))

  return (
    <div className="component-header">
      <div className="component-header__main-container">
        {/* Close Icon */}
        <div style={{ display: "flex" }}>
          <div className="component-header__level-indicator">
            Level {props.level} of {TOTAL_LEVEL}
          </div>
          {/*<div*/}
          {/*  style={{ marginLeft: 5 }}*/}
          {/*  className="component-header__level-indicator"*/}
          {/*>*/}
          {/*  Life remaining {props.lives}*/}
          {/*</div>*/}
        </div>

        {/* Time Progress Bar */}
        {/*<div className="component-header__time-progress">*/}
        {/*  <div*/}
        {/*    className={`component-header__time-progress--highlight ${*/}
        {/*      getRemainingTimePercentage(props.timeLeft, props.level) > 95*/}
        {/*        ? "rounded"*/}
        {/*        : ""*/}
        {/*    }`}*/}
        {/*    style={{*/}
        {/*      width:*/}
        {/*        getRemainingTimePercentage(props.timeLeft, props.level) + "%",*/}
        {/*    }}*/}
        {/*  ></div>*/}
        {/*  <p className="component-header__time-progress--text">*/}
        {/*    {getFormattedNumber(props.timeLeft.minute)}:*/}
        {/*    {getFormattedNumber(props.timeLeft.second)}*/}
        {/*  </p>*/}
        {/*</div>*/}
        <div className="component-header__life-remaining">
          {Array(props.initialLives).fill("Dummy").map((v, index) => <motion.img
            key={v + index}
            src={
              index <= props.lives - 1
                ? require("../../static/img/heart.svg")
                : require("../../static/img/empty-heart.svg")
            }
            animate={index <= props.lives - 1 ? "inital" : "final"}
            transitionEnd
            variants={variants}
            alt="lives"
            style={{ marginRight: 7 }}
          />)}
        </div>

        {/* Sound Icon */}
        <div>
          <img
            id="sound-button"
            onClick={(e) => {
              if (!isBgAudioPlaying) {
                backgroundMusicStart()
              } else {
                backgroundMusicStop()
              }
              localStorage.setItem("playMusic", JSON.stringify(!isBgAudioPlaying))
            }}
            style={{ marginRight: 10 }}
            src={
              !isBgAudioPlaying
                ? require("../../static/img/MuteSpeaker.png")
                : require("../../static/img/SpeakerIcon.png")
            }
            className="component-header__icon"
            alt="TabBerry"
          />
          {/*<img*/}
          {/*  src={require("../../static/img/cross-icon.svg")}*/}
          {/*  // onClick={() => props.setSoundEffect(!props.soundEffect)}*/}
          {/*  // className={*/}
          {/*  //   "img-menu-control cursor-pointer" +*/}
          {/*  //   (!props.soundEffect ? " audio-disable" : "")*/}
          {/*  // }*/}
          {/*  className="component-header__icon"*/}
          {/*  alt="Close icon"*/}
          {/*/>*/}
        </div>
      </div>
    </div>
  );
}

export default Header;
